"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createStore } from "zustand/vanilla";
import { subscribeWithSelector } from "zustand/middleware";
import filterStore from "./filterStore";
import dropdownFilterStore from "./dropdownFilterStore";
import L from "../leaflet";
const store = createStore(
  subscribeWithSelector((set, get) => ({
    locale: "en",
    defaultLocale: "en",
    selected_component: void 0,
    defaultSelectedPoint: void 0,
    space_ids: [],
    images: {},
    tile: void 0,
    pageName: "",
    map: void 0,
    mapReady: false,
    pointsLayer: L.layerGroup(),
    scopeLayer: L.layerGroup(),
    isIndex: false,
    mapID: "Generic",
    map_config: {},
    i18n: {},
    isAsideOpen: false,
    isFullscreen: false,
    isSmallScreen: false,
    activeManifests: [],
    closeAside: () => __async(void 0, null, function* () {
      const wasClosed = !get().isAsideOpen;
      if (wasClosed) return;
      set(() => ({ isAsideOpen: false }));
      return new Promise((resolve) => setTimeout(resolve, 520));
    }),
    openAside: () => __async(void 0, null, function* () {
      const wasOpen = get().isAsideOpen;
      if (wasOpen) return;
      set(() => ({ isAsideOpen: true }));
      return new Promise((resolve) => setTimeout(resolve, 520));
    }),
    setFullscreen: (fullscreen) => set({ isFullscreen: !!fullscreen }),
    setReady: () => set({ mapReady: true }),
    setConfig: (mapConfig) => {
      const findPageName = () => {
        const [titleTag] = document.getElementsByTagName("title");
        const [titleContent] = (titleTag.textContent || "").split(" - ");
        return titleContent || "Home";
      };
      set(() => ({
        locale: mapConfig.locale,
        defaultLocale: mapConfig.default_locale,
        pageName: findPageName(),
        selected_component: mapConfig.selected_component,
        space_ids: mapConfig.space_ids,
        defaultSelectedPoint: mapConfig.selected_point,
        mapID: mapConfig.mapID,
        map_config: mapConfig.map_config,
        i18n: mapConfig.i18n,
        images: mapConfig.images || {},
        isIndex: mapConfig.is_index === "true" || mapConfig.is_index === true,
        activeManifests: mapConfig.active_manifests,
        filters: mapConfig.filters
      }));
      const { setDefaultFilters, setFilters, toFilterOptions } = filterStore.getState();
      setDefaultFilters(mapConfig.filters);
      setFilters(mapConfig.filters);
      dropdownFilterStore.getState().setDefaultFilters({
        GeoScopeFilter: toFilterOptions("GeoScopeFilter", mapConfig.filters),
        GeoShowFilter: toFilterOptions("GeoShowFilter", mapConfig.filters),
        GeoTimeFilter: toFilterOptions("GeoTimeFilter", mapConfig.filters),
        GeoType: toFilterOptions("GeoType", mapConfig.filters),
        GeoSource: toFilterOptions("GeoSource", mapConfig.filters)
      });
    }
  }))
);
store.subscribe(
  ({ isAsideOpen }) => [isAsideOpen],
  ([isAsideOpen], [wasAsideOpen]) => {
    if (isAsideOpen && !wasAsideOpen) dropdownFilterStore.getState().close();
  }
);
export default store;
